export const CAConstant: any = {
  TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  USER_DISPLAY_NAME: "user_display_name",
  PROJECT_ID: "ca",
  UXF_TOKEN: "uxfToken",
  USER_ID: "userId",
  ID_TYPE: "idType",
  EXPIRED_TIME: "900000",
  COMMERCE_CHANNEL_CODE: "SS",
  RP_CHANNEL_CODE: "MC",
  TSP_CHANNEL_CODE: "TSP",

  dateFormatConstant: "DD/MM/YYYY",
  pdfFileDateFormatConstant: "DDMMMYYYY",

  SUCCESS_STATUS: "success",
  FAILED_STATUS: "failed",
  ACCEPTED_STATUS: "accepted",
  EXPIRED_STATUS: "expired",
  VERIFICATION_STATUS: "verification",
  VERIFIED_STATUS: "verified",

  ORDER_NOT_FOUND: "ORDER_NOT_FOUND",
  IDVALUE_MATCHED: "IDVALUE_MATCHED",
  IDVALUE_MISMATCHED: "IDVALUE_MISMATCHED",
  IDVALUE_MAXATTEMPT: "IDVALUE_MAXATTEMPT",

  ECOMPRIVACY: "ECOMPRIVACY",

  GTC_FullText: "General Terms and Conditions",
  SSTC_FullText: "Service Specific Terms and Conditions",
  MaxisPrivaryNotice: "Maxis Privacy Notice",
  
  WISH_TO_SUBSCRIBE: "I/We wish to subscribe for the Services provided by Maxis Broadband Sdn Bhd.",
  INFO_IS_CORRECT: "The above information provided is true and correct.",
  TNCANDSSTC: "I have read and accepted the General Terms and Conditions and Service Specific Terms and Conditions.",
  MAXIS_PRIVACY_STATEMENT_FULL: "I/We hereby consent to the collection and processing of my personal information in accordance with the Maxis Group Privacy Notice (at <a target='_blank' href='https://www.maxis.com.my/en/privacy-notice/'>https://www.maxis.com.my/en/privacy-notice/</a>).",
  ECOMZEROLUTIONAUDIO: "If I/we subscribe to the Maxis Zerolution Plan, I/we hereby acknowledge to have been orally notified and given sufficient notice and I/we agree that Maxis shall have the right to, with advance notice in a manner Maxis deems appropriate, including by electronic mail, SMS and pop-up notifications, incrementally or progressively suspend and/or block the Services and/or the usage of the relevant Mobile Phone or Mobile Device, including as described below, if I/we default in payment: - <ol type='i' class='terms-text roman'><li>Services will be interrupted (no outgoing calls; social media applications are not accessible) </li><li>Messaging applications will be blocked, </li><li>Device will be blocked (all device functionalities will not be usable), and</li><li>If your Account is barred or suspended or if you have not paid your Maxis Bill for more than 30 days consecutively, your subscription to the Maxis Device Care Program (if any) will be automatically terminated.</li></ol>",
  ACKNOWLEDGEMET_TEXT: "Please note that the order fulfillment is subject to eligibility checks at the point of delivery/collection.",
  AGREE_FOR_URL_PLACEMENT: "I/We have read and agree to be bound by the contract terms here with and all other terms and conditions printed and/or attached hereto and any amendments made thereto.",
  AGREE: "I have read and accepted the General Terms and Conditions and  <a target='_blank' href='contenturl'>Service Specific Terms and Conditions</a>.",
  DEVICE_CARE: "If I/we have subscribed to Maxis Device Care, I/we hereby expressly confirm that I/we am/are Malaysian, and consent to the disclosure and sharing of my/our personal data (whether directly by me/us or through Maxis) with AIA and the processing of such data by AIA in accordance with AIA’s Privacy Statement for the purposes stated therein and in connection with AIA’s insurance products. I/We further agree that I/we have read, understood, and hereby agree to AIA’s Terms of Use, Important Notice, Declaration, Policy Wording and Product Disclosure Sheet by AIA.",
  FEE_CHARGED: "The following fees (“Fees”) will be applicable and charged to you: <ol type='i' class='terms-text roman'><li>one-time processing fee – if you register for a new principal line with any of the Plans; and/or </li><li>one-time SIM fee – for us to provision a new SIM Card or eSIM to you. </li></ol><li>The Fees (if applicable) will be charged and reflected in your Bill.</li>",

  UNABLE_TO_PROCEED: "We are unable to proceed due to the wrong password entered. For assistance, please dial 123.",
  PASSWORD_MISMATCHED: "Password mismatched",
  ORDER_NOT_EXISTS: "This order is not found.",
  ALREADY_ACCEPTED: "You have already accepted the order acknowledgement.",
  LINK_EXPIRED: "The link has expired",

  CONSENT: {
    REQUIRED_CAID: "Customer Acknowledgement ID (caid) is required.",
    CAID_NOT_FOUND: "Invalid Customer Acknowledgement ID (caid).",
    EXPIRED_TITLE: "The link has expired",
    ACKNOWLEDGED_TITLE: "Already Acknowledged",
    ACKNOWLEDGED_TEXT: "You have already accepted the acknowledgement on {dateAccepted} at {timeAccepted}.",
    ACCEPT_TITLE: "Acknowledgement Completed",
    ACCEPT_TEXT_EMAIL: "Success! Your email has been verified.",
    ACCEPT_TEXT_SSTC: "Acknowledgement Completed. You can close the page. Thanks.",
    ACCEPTED_STATUS: "A",
    EXPIRED_STATUS: "E",
  }
};
 